import React from "react";
import { useNavigate } from "react-router-dom";
import '../../assets/css/style.css';
import Copybtn from '../../assets/img/copy.svg';
import Unlockimg from '../../assets/img/unlock.svg';
import LockBtn from '../../assets/img/lock.svg';
import { useState, useEffect } from "react";


const GiftsDan = () => {
  const navigate = useNavigate();



  useEffect(() => {
    const donetoken = localStorage.getItem("donetoken");
    if (donetoken) {
      // اگر توکن وجود دارد، وارد پنل شود
    }else{
      navigate("/");
    }
  }, [navigate]);



  const [Userrefcode, setUserrefcode] = useState(0);
  const [invitedUser, setinvitedUser] = useState(0);
  const [refcount, setrefcount] = useState(0);
  
  useEffect(() => {
    const userInfo = JSON.parse(localStorage.getItem("userinfo"));
    
    if (userInfo) {
      setUserrefcode(userInfo.ref_code || 0);
      setinvitedUser(userInfo.ref_count || 0);
      setrefcount(userInfo.ref_count || 0);

    }
    
  }, []);
  
  const copyToClipboard = () => {
    navigator.clipboard.writeText(Userrefcode)
      .then(() => {
        alert("✅ کد دعوت با موفقیت کپی شد!");
      })
      .catch(err => console.error("خطا در کپی کردن: ", err));
  };

  return (
   <>
  <div className="mohtava-mine" >
    
<section id="gifts" className="dir-r max-cntt-w" >
  

        
        <div className="gift-div-1" >
    <div className="gift-div-2" >
    <button className="gift-ref-btn-1" onClick={copyToClipboard}>
    کد دعوت : 
    <span id="myrefcode">{Userrefcode}</span>
    <img src={Copybtn} className="mr-5" alt="copy" />
  </button>

<button  onClick={() => navigate("/panel/reffral-list")} 
className="gift-ref-btn-2"
>نفرات دعوت شده:  
{invitedUser}
</button>




</div>


  
</div>






<div id="steps" className="gift-step-div-1"  >

        <div id="mohtavaha" className="gift-mohtava-1">
            
        <p className="gift-stap-p-1" >
        مرحله اول: قدردانی و آغاز دوستی!
        </p>
        <p className="gift-stap-p-2" >
        با دعوت به عمل آوردن از ۳ نفر از دوستان خود، مبلغ واریزی اتان بابت خرید اشتراک دان به پاس قدردانی از حمایت شما به حسابتان بازخواهد گشت.
            </p>
            <p className="gift-stap-p-3" >
        مرحله دوم: کنسرت این ماه رو مهمون دان!
        </p>
        <p className="gift-stap-p-4" >
   مثل مرحله قبل در این مرحله با دعوت از ۳ نفر از دوستان خود دو بلیط رایگان کنسرت به عنوان جایزه تقدیم حضورتان می&zwnj;گردد.     
    </p>
    
    
        
        <p 
        className="gift-stap-p-5"
        >مرحله سوم: یک سفر کیش مهمون دان!</p>
        
        <p 
        className="gift-stap-p-6"
        >مثل مرحله قبل در این مرحله با دعوت از ۲۴ نفر از دوستان خود یک بلیط سفر به جزیره ی زیبای کیش به همراه اقامت در هتل ۵ ستاره مهمون دان!!</p>
        
        <p 
        className="gift-stap-p-7"
        >مرحله چهارم: سفر رویایی جزیره مارماریس!</p>
        
        <p 
        className="gift-stap-p-8"
        >مثل مرحله قبل در این مرحله با دعوت از ۱۲۰ نفر از دوستان خود یک بلیط رایگان سفر به جزایر رویایی مارماریس به همراه رزرو هتل رو مهمون دان باشید!!!</p></div>
        
        <div id="navarghofl" className="gift-step-nav-1" >
    

        
<button className={refcount >= 2 ? "gift-step-nav-btn-1" : "gift-lock-btn-1"}  >
<img src={refcount >= 2 ? Unlockimg : LockBtn} alt="unlock" />
</button>
<button className={refcount >= 5 ? "gift-step-nav-btn-1" : "gift-lock-btn-1"} >
<img src={refcount >= 5 ? Unlockimg : LockBtn} alt="lock" />
</button>
<button className={refcount >= 29 ? "gift-step-nav-btn-1" : "gift-lock-btn-1"} >
<img src={refcount >= 29 ? Unlockimg : LockBtn} alt="lock" />
</button>
<button className={refcount >= 149 ? "gift-step-nav-btn-1" : "gift-lock-btn-1"} >
<img src={refcount >= 149 ? Unlockimg : LockBtn} alt="lock" />
</button>

</div>
        
        
        </div>






      <div className="h-100">
          
      </div>
  
      </section>

  </div>
   </>
      
  );
};

export default GiftsDan;
